import Vue from 'vue'
import App from './App'
import router from './router'
import MainView from './components/MainView.vue'
// import Car from '../common/components/Car.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import '../common/css/common.css'
import '../common/css/animate.css'
Vue.use(ElementUI);
import { o2vr } from '../common/js/o2'
Vue.prototype.$Bus = new Vue()
document.Bus = Vue.prototype.$Bus;
// import { o2builder } from '@/assets/js/o2_builder'

Vue.component('mainview', MainView)

// Vue.component('Car', Car)
Vue.config.productionTip = false
Vue.prototype.O2vr = new o2vr()
document.o2vr = Vue.prototype.O2vr;
//Vue.prototype.O2Builder = new o2builder()

/* eslint-disable no-new */
// import store from "./store";

// Vue.config.productionTip = false;

new Vue({
    router,
    // store,
    render: h => h(App)
}).$mount("#app");
